import { WBPermissionType } from "../enum/workbook-permission.enum";

export const getWBPermissionStatus: { [key: number]: 'success' | 'info' | 'warning' | 'danger' } = {
    [WBPermissionType.NoAccess]: 'danger',
    [WBPermissionType.Read]: 'info',
    [WBPermissionType.ReadWrite]: 'warning',
    [WBPermissionType.AllAccess]: 'success'
  };

  export const getWBPermissionIcon: { [key: number]: string } = {
    [WBPermissionType.NoAccess]: 'pi pi-times-circle',
    [WBPermissionType.Read]: 'pi pi-eye',
    [WBPermissionType.ReadWrite]: 'pi pi-pencil',
    [WBPermissionType.AllAccess]: 'pi pi-shield'
  };
  
  export const getWBPermissionName: { [key: number]: string } = {
    [WBPermissionType.NoAccess]: 'No Access',
    [WBPermissionType.Read]: 'Read Access',
    [WBPermissionType.ReadWrite]: 'Read & Write Access',
    [WBPermissionType.AllAccess]: 'All Access'
  };  